import { skipToken, useQuery } from '@tanstack/react-query';

import { apiClient } from 'core/api/globals';

import { AuthenticationScheme, useAuthentication } from 'features/auth';

export function useQueryServices() {
  const { activeScheme } = useAuthentication();

  const ageRangesQuery = useQuery({
    queryKey: ['services'],
    queryFn:
      // Skip services query in share mode - services are not needed for share functionality
      activeScheme === AuthenticationScheme.SHARE ? skipToken : apiClient.servicesClient.getAllServices,
    staleTime: Infinity,
  });

  return ageRangesQuery;
}
